(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("dashboardSuperAdmin", {
        templateUrl: "app/dashboard/dashboardSuperAdmin.component.html",
        controller: ["dashboardResource", "accountDashboardResource", "messageService", "colorService", "$state", "$translate", DashboardSuperAdminCtrl],
        controllerAs: "vm"
    });
    function DashboardSuperAdminCtrl(dashboardResource, accountDashboardResource, messageService, colorService, $state, $translate) {
        var vm = this;
        vm.chartOptions = { thickness: 7, mode: "gauge", total: 100 };
        vm.isReadOnly = $state.params.isReadOnly;
        if (vm.isReadOnly) {
            dashboardResource.getSuperAdminViewModel({ personSeq: $state.params.personSeq }, function (data) {
                process(data);
            }, function (error) {
                messageService.error(error);
            });
        }
        else {
            accountDashboardResource.getSuperAdminViewModel(function (data) {
                process(data);
            }, function (error) {
                messageService.error(error);
            });
        }
        /////////////////////////////////////////////////////////////
        function process(data) {
            vm.data = data;
            vm.data.siteCompletionChart = [
                {
                    label: $translate.instant("settings.tenancySetup.panel.siteSetupCompletion.completedLabel"),
                    value: vm.data.percentCompletion,
                    color: vm.data.percentCompletion === 100 ? colorService.getSuccessColor() : colorService.getDangerColor(),
                    suffix: "%"
                }
            ];
            vm.loaded = true;
        }
        vm.loadSiteSetup = function () {
            if (!vm.isReadOnly)
                $state.go("main.settings.gettingStarted");
        };
        vm.loadSelfRegistration = function () {
            if (!vm.isReadOnly)
                $state.go("main.settings.registration.panels");
        };
        vm.loadGamification = function () {
            if (!vm.isReadOnly)
                $state.go("main.settings.gamification");
        };
        vm.loadStoreFront = function () {
            if (!vm.isReadOnly)
                $state.go("main.settings.storefront");
        };
        vm.loadSubscription = function () {
            if (!vm.isReadOnly)
                $state.go("main.settings.subscription");
        };
        vm.loadOpenBadges = function () {
            if (!vm.isReadOnly)
                $state.go("main.settings.openBadges");
        };
    }
}());
